export default __webpack_public_path__ + "static/media/early_adopters.ab4e1685.png";